import config from '@/config'

export default {
	id: 'SIMPLE_PAYWALL_1M_29_99_1W_4',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_1m_29_99_1w_4_usd',
			EUR: 'simple_premium_1m_29_99_1w_4_eur',
			GBP: 'simple_premium_1m_29_99_1w_4_gbp',
			CAD: 'simple_premium_1m_49_99_1w_6_cad',
			AUD: 'simple_premium_1m_49_99_1w_6_aud',
			SEK: 'simple_premium_1m_399_1w_59_sek',
			TRY: 'simple_premium_1m_999_1w_133_trl',
			MXN: 'simple_premium_1m_499_1w_66_mxn',
			NOK: 'simple_premium_1m_399_1w_59_nok',
			DKK: 'simple_premium_1m_259_1w_39_dkk',
			BRL: 'simple_premium_1m_199_99_1w_25_99_brl',
			ARS: 'simple_premium_1m_39990_1w_6000_ars',
			COP: 'simple_premium_1m_119990_1w_17000_cop',
			CLP: 'simple_premium_1m_29990_1w_4000_clp',
		},
		primer: 'prd_BsH5gd1ddA5A',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'week',
		next_period_value: 1,
		next_period_type: 'month',
	},
	trial: {
		days: 7,
		priceMap: {
			USD: 4.0,
			EUR: 4.0,
			GBP: 4.0,
			CAD: 6,
			AUD: 6,
			SEK: 59,
			TRY: 133,
			MXN: 66,
			NOK: 59,
			DKK: 39,
			BRL: 25.99,
			ARS: 6000,
			COP: 17000,
			CLP: 4000,
		},
		originalPriceMap: {
			USD: 29.99,
			EUR: 29.99,
			GBP: 29.99,
			CAD: 49.99,
			AUD: 49.99,
			SEK: 399,
			TRY: 999,
			MXN: 499,
			NOK: 399,
			DKK: 259,
			BRL: 199.99,
			ARS: 39990,
			COP: 119990,
			CLP: 29990,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 29.99,
			EUR: 29.99,
			GBP: 29.99,
			CAD: 49.99,
			AUD: 49.99,
			SEK: 399,
			TRY: 999,
			MXN: 499,
			NOK: 399,
			DKK: 259,
			BRL: 199.99,
			ARS: 39990,
			COP: 119990,
			CLP: 29990,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.7_days.into_period_text'), // 'first week'
		explicitTermsIntervalText: $t('pages.program.organic.cheap_and_short.plans.7_days.sub_period_text'), // 'monthly'
		billingSubtitlePeriodText: $t('pages.program.cheap_and_short.plans.7_days.into_period_text'), // 'first week'
		footerPeriodText: $t('pages.program.cheap_and_short.plans.7_days.period_text'), // '1-week'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.7_days.sub_period_text'), // 'monthly'
	}),
}
